import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";
import {SELOBEVENTNAMES} from "@k/global/GlobalEventnames";
import {HistoryController} from "../history/historyController";
import globalsObject from "../globalsObject";

export class DruckbereichSelObLoescher extends EventListener{
    public constructor() {
        super();
        this.addEventListener("objectInteractionEndingEvent", (id)=>DruckbereichSelObLoescher.selObChanged(id))
    }


    private static partSelObWithIDHasLeftDruckbereich(id:string) {
        const partSelOb = globalsObject.owayoJSViewer.getPartSelObById(id);
        return partSelOb !== null && partSelOb.isOutOfDruckBereich();
    }

    private static selObChanged(id:string) {
        if(!DruckbereichSelObLoescher.partSelObWithIDHasLeftDruckbereich(id)) {
            return;
        }

        // EventVerteiler.broadcastBlockRequest("seloboutofDruckbereich")
        EventVerteiler.broadcast("displayDialogEvent", {
            dialog:"deleteObjectOutOfDruckbereich",
            closeButtonInside:false,
            callbacks: [
                ()=>{
                    EventVerteiler.broadcast(SELOBEVENTNAMES.DELETEREQUEST_WithoutHistory, id)
                    EventVerteiler.broadcastBlockRequestEnded("seloboutofDruckbereich");
                },
                ()=>{
                    setTimeout(()=>EventVerteiler.broadcast(HistoryController.UNDO_WITHOUT_REDO_EVENT), 10)
                    EventVerteiler.broadcastBlockRequestEnded("seloboutofDruckbereich");
                }
            ]
        })
    }
}
